import { render, staticRenderFns } from "./LiefengIndexModal.vue?vue&type=template&id=57370e6d&scoped=true&"
import script from "./LiefengIndexModal.vue?vue&type=script&lang=js&"
export * from "./LiefengIndexModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57370e6d",
  null
  
)

export default component.exports